module.exports = {
  rootUrl: "https://ballerized-api.herokuapp.com",
  googleClientId:
    "607390657907-v3fus8ipprve9j2is8krhr3cj0n8me2g.apps.googleusercontent.com",
};
